import { useNavigate } from 'react-router-dom'
import { ShieldX } from 'lucide-react'
import { AuthLayout } from '../components/AuthLayout'
import { FormButton } from '../components/FormButton'

export function NoAccessPage() {
  const navigate = useNavigate()

  return (
    <AuthLayout
      title="No access"
      subtitle="You do not have sufficient permissions to access this application."
    >
      <div className="flex flex-col items-center gap-6 py-4">
        <ShieldX size={48} className="text-gray-400" />
        <p className="text-sm text-gray-600 text-center">
          Please contact your administrator to request access.
        </p>
        <FormButton
          onClick={() => navigate('/auth/logout')}
          variant="secondary"
          fullWidth
        >
          Sign out
        </FormButton>
      </div>
    </AuthLayout>
  )
}
